module.exports = "https://assets.sidelineswap.com/web/_next/static/images/mobile-hero-31cadf77c6091be93743382613d8bab9.jpg";